module.exports = __webpack_public_path__ + "img/tn.c8d5dd88.svg";